<template>
  <div></div>
</template>
<script>
export default {
  name: "presentationGazVolt",
};
</script>
